<template>
  <div id="main-container">
    <div v-if="loading" class="loading-container">
      <Loader />
    </div>
    <router-view v-else id="main-scroll-app" :key="$route.fullPath" class="view-container" />
  </div>
</template>
<script>
import Loader from '@/components/Loader.vue'
import { getLocale, setI18nLanguage } from '@/i18n.js'

export default {
  name: 'App',
  components: {
    Loader
  },
  data() {
    return {
      loading: true
    }
  },
  async mounted() {
    // set i18n language
    setI18nLanguage(getLocale())

    this.loading = false
  },
  methods: {
    getLanguage() {
      let locale = navigator.language
      if (locale.length === 2) {
        locale = `${locale}-${locale.toUpperCase()}`
      }

      if (Object.keys(this.$i18n.messages).includes(locale)) {
        return locale
      } else if (locale.includes('en')) {
        if (locale.includes('GB')) {
          return 'en-GB'
        } else if (locale.includes('CA')) {
          return 'en-CA'
        }
        return 'en-US'
      } else if (locale.includes('fr')) {
        return 'fr-FR'
      } else if (locale.includes('de')) {
        return 'de-DE'
      } else if (locale.includes('es')) {
        return 'es-ES'
      } else if (locale.includes('it')) {
        return 'it-IT'
      } else {
        return 'en-US'
      }
    }
  }
}
</script>
<style scoped>
#main-container {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-overflow: ellipsis;
  min-height: 100vh;
  text-align: center;
  color: #292929;
  display: flex;
  flex-direction: column;
  line-height: 14px;
  justify-content: center;
  max-width: 800px;
  margin: 0 auto;
}
</style>
